import { Box, Button, Grid, TextField } from '@mui/material';
import { useState, useEffect } from 'react';

export default function CompraForm({ onSubmit, editing }) {
  const [form, setForm] = useState({
    fecha: '',
    proveedor: '',
    concepto: '',
    categoria: '',
    monto: '',
    metodoPago: ''
  });

  useEffect(() => {
    if (editing) setForm(editing);
  }, [editing]);

  const handleChange = e =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = () => {
    if (!form.monto) return alert('Monto requerido');
    onSubmit(form);
    setForm({
      fecha: '',
      proveedor: '',
      concepto: '',
      categoria: '',
      monto: '',
      metodoPago: ''
    });
  };

  return (
    <Box>
      <Grid container spacing={2}>
        {['fecha','proveedor','concepto','categoria','metodoPago','monto'].map(f => (
          <Grid item xs={12} sm={6} key={f}>
            <TextField
              fullWidth
              type={f === 'monto' ? 'number' : f === 'fecha' ? 'date' : 'text'}
              label={f.toUpperCase()}
              name={f}
              value={form[f]}
              onChange={handleChange}
              InputLabelProps={f === 'fecha' ? { shrink: true } : {}}
            />
          </Grid>
        ))}
      </Grid>

      <Button
        variant="contained"
        sx={{ mt: 2 }}
        fullWidth
        onClick={handleSubmit}
      >
        {editing ? 'Actualizar Compra' : 'Guardar Compra'}
      </Button>
    </Box>
  );
}
